import React from 'react';
interface SectionCardProps {
  title?: string;
  children: ReactNode;
}
export function SectionCard({
  title,
  children
}: SectionCardProps) {
  return <div className="bg-white rounded-xl border border-gray-200 p-4" data-id="element-127">
      {title && <h3 className="text-base font-semibold text-gray-900 mb-2.5" data-id="element-128">
          {title}
        </h3>}
      {children}
    </div>;
}